import Vue from 'vue';
import { exportData } from '../../utils/common-export-polling';
export default Vue.extend({
    name: 'exportBtnModel',
    data: function () {
        return {};
    },
    props: {
        url: {
            type: String,
            default: function () {
                return '';
            },
        },
        keyUrl: {
            type: String,
            default: '',
        },
        keyMethod: {
            type: String,
            default: '',
        },
        statusUrl: {
            type: String,
            default: '',
        },
        statusMethod: {
            type: String,
            default: '',
        },
        params: {
            type: Object,
            default: function () {
                return {};
            },
        },
        isExport: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        exportExcel: function () {
            if (!this.isExport)
                return this.$message.error('列表为空');
            var _a = this, keyUrl = _a.keyUrl, keyMethod = _a.keyMethod, statusUrl = _a.statusUrl, statusMethod = _a.statusMethod, params = _a.params;
            exportData({
                keyUrl: keyUrl,
                keyMethod: keyMethod,
                statusUrl: statusUrl,
                statusMethod: statusMethod,
                params: params,
            });
            // this.$request({
            //   url: this.url,
            //   method:'post',
            //   data: {
            //     ...this.params
            //   }
            // }).then((res) => {
            //   if(!res.errorCode) {
            //     if(res.data && res.data.result) {
            //       location.href = res.data.downloadurl
            //     }
            //   }
            // })
        },
    },
});
